import { useState, useEffect } from "react";
import { chatApi } from "../../api";

const FALLBACK = [
  "Who were the top 5 winners yesterday?",
  "Show me total GGR by sport yesterday",
  "How many bets were placed this week?",
  "Who were the top 5 losers yesterday?",
  "What is the total staked amount today?",
  "Show player balance snapshots for today",
];

interface SuggestedQuestionsProps {
  onSelect: (question: string) => void;
  agentName?: string;
  compact?: boolean;
}

export default function SuggestedQuestions({ onSelect, agentName = "Brian", compact = false }: SuggestedQuestionsProps) {
  const [questions, setQuestions] = useState<string[]>(FALLBACK);

  useEffect(() => {
    chatApi.getSuggestedQuestions()
      .then((res) => {
        const qs: string[] = res.data?.map((q: { question: string }) => q.question) ?? [];
        if (qs.length > 0) setQuestions(qs);
      })
      .catch(() => {}); // keep fallback on error
  }, []);

  if (compact) {
    return (
      <div className="grid w-full gap-2 sm:grid-cols-2">
        {questions.map((q) => (
          <button
            key={q}
            onClick={() => onSelect(q)}
            className="rounded-xl border border-gray-200 bg-white px-4 py-3 text-left text-sm text-gray-700 shadow-sm transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700"
          >
            {q}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center flex-1 px-6 py-12">
      <div className="mb-2 text-2xl font-semibold text-gray-800">{agentName}</div>
      <p className="mb-8 text-sm text-gray-500">Ask me anything!</p>
      <div className="grid w-full max-w-xl gap-2 sm:grid-cols-2">
        {questions.map((q) => (
          <button
            key={q}
            onClick={() => onSelect(q)}
            className="rounded-xl border border-gray-200 bg-white px-4 py-3 text-left text-sm text-gray-700 shadow-sm transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700"
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
